import { render, staticRenderFns } from "./ReceiptApply.vue?vue&type=template&id=cfccb8b8&scoped=true&"
import script from "./ReceiptApply.vue?vue&type=script&lang=js&"
export * from "./ReceiptApply.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptApply.vue?vue&type=style&index=0&id=cfccb8b8&lang=scss&module=true&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "cfccb8b8",
  null
  
)

export default component.exports